import * as React from 'react';

const LogoFacebookGreySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 20 20" {...props}>
        <path
            d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.879V12.89h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.989C16.343 19.129 20 14.99 20 10"
            fill="#BDC1C5"
        />
        <path
            d="M13.893 12.89l.443-2.89h-2.773V8.124c0-.79.387-1.562 1.63-1.562h1.26v-2.46s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V10h-2.54v2.89h2.54v6.989a10.075 10.075 0 003.124 0V12.89h2.33"
            fill="#FFF"
        />
    </svg>
);

LogoFacebookGreySvg.displayName = 'LogoFacebookGreySvg';
export default LogoFacebookGreySvg;
